module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-ext_latin-regular.d679a906.woff";